<template>
    <v-dialog :value="errorDialog.isVisible()" :width="520" persistent>
        <v-card>
            <v-card-title v-if="errorDialog.getTitle() !== null" class="headline error--text" style="word-break: break-word">{{ errorDialog.getTitle() }}</v-card-title>
            <v-card-text v-if="errorDialog.getContent() !== null" :class="errorDialog.getTitle() === null ? 'pt-4' : ''" class="body-1" v-html="errorDialog.getContent()"></v-card-text> <!-- WARNING! THIS CAN BE ARBITRARY! -->
            <v-card-actions class="pa-3">
                <v-spacer></v-spacer>
                <primary-button @click="errorDialog.onCloseClick()">
                    {{ errorDialog.getButtonText() }}
                </primary-button>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { reactive } from "@vue/composition-api";
import { $t } from "@/i18n";
import ErrorDialog from "./errorDialog";

export default {
    name: "ErrorDialog",
    setup() {
        const errorDialog = reactive(ErrorDialog)

        return {
            errorDialog
        };
    }
};
</script>
